/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MyChartSendNewDocumentAliases {
  CONTEXTUAL_BAR_NEW_DOCUMENT_MY_CHART_SEND_NEW_DOCUMENT = 'contextual-bar-new-document-my-chart-send-new-document',
  FIELD_FILE_UPLOADER = 'field-file-uploader',
  FILE_UPLOADER = 'file-uploader',
  FORM_NEW_DOCUMENT = 'form-new-document',
  NEW_DOCUMENT_LAYOUT = 'new-document-layout',
}
export { MyChartSendNewDocumentAliases };
